import script from "./RopesHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./RopesHeader.vue?vue&type=script&setup=true&lang=js"

import "./RopesHeader.vue?vue&type=style&index=0&id=0c14da4b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c14da4b"]])

export default __exports__